export default "__VITE_ASSET__CKP03Bmz__"